import axios from 'axios';

export default {
    PhoneticConvert: function (version, input, sequence, sadakhataCookie, resolve) {
        let uri = '/api/convert';
        axios.post(uri, {
            version,
            input,
            sequence,
            sadakhataCookie
        }).then(resolve);
    }
};
